import { Routes } from '@angular/router'

export const homeRoutes: Routes = []
